import { render, staticRenderFns } from "./KpiGeshi.vue?vue&type=template&id=bab7d34c&scoped=true&"
import script from "./KpiGeshi.vue?vue&type=script&lang=js&"
export * from "./KpiGeshi.vue?vue&type=script&lang=js&"
import style0 from "./KpiGeshi.vue?vue&type=style&index=0&id=bab7d34c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab7d34c",
  null
  
)

export default component.exports